var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "DialogPlaceInPlan", attrs: { dir: "rtl" } },
    [
      _c(
        "div",
        { staticClass: "modal-card", staticStyle: { width: "460px" } },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("שיבוץ משימות בתכנית"),
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c("p", { staticClass: "DialogPlaceInPlan__Count" }, [
                _vm._v(" נבחרו "),
                _c("b", [_vm._v(_vm._s(_vm.tasks.length))]),
                _vm._v(" משימות לשיבוץ, סה״כ זמן "),
                _c("b", [_vm._v(_vm._s(_vm.totalTime))]),
                _vm._v(". "),
              ]),
              _c(
                "b-field",
                { attrs: { label: "סוג תוכנית" } },
                [
                  _c(
                    "b-select",
                    {
                      attrs: { placeholder: "בחר סוג תוכנית", expanded: "" },
                      model: {
                        value: _vm.programTypeId,
                        callback: function ($$v) {
                          _vm.programTypeId = $$v
                        },
                        expression: "programTypeId",
                      },
                    },
                    _vm._l(_vm.programTypes, function (p) {
                      return _c(
                        "option",
                        { key: p.Value, domProps: { value: p.Value } },
                        [_vm._v(_vm._s(p.Text))]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "תאריך" } },
                [
                  _c("b-datepicker", {
                    attrs: {
                      icon: "calendar-today",
                      placeholder: "בחר תאריך",
                      "trap-focus": "",
                      editable: "",
                    },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
              _c("b-field", { attrs: { label: "חלון זמן" } }, [
                _c(
                  "div",
                  { staticClass: "time-window" },
                  _vm._l(_vm.timeWindows, function (w) {
                    return _c(
                      "button",
                      {
                        key: w.Value,
                        class: { on: _vm.timeWindow === w.Value },
                        style:
                          _vm.timeWindow === w.Value
                            ? {
                                background: w.color,
                                borderColor: w.color,
                                color: "#fff",
                              }
                            : {},
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.timeWindow = w.Value
                          },
                        },
                      },
                      [
                        _c("span", {
                          staticClass: "dot",
                          style: { background: w.color },
                        }),
                        _vm._v(_vm._s(w.Text) + " "),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "note" }, [
                _vm._v("כל משימה שכבר שובצה בתכנית זו תדולג."),
              ]),
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c("b-button", {
                attrs: {
                  loading: _vm.isLoading,
                  disabled: _vm.programTypeId == null,
                  type: "is-primary",
                  label: "שבץ",
                },
                on: { click: _vm.save },
              }),
              _c("b-button", {
                attrs: { disabled: _vm.isLoading, label: "ביטול" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }